import React from 'react'
import Label from 'lib/Label'
import "./index.scss"
import { Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import './index.scss'
import ErrorMessage from 'lib/ErrorMessage';
import { ToastContainer, toast } from 'react-toastify';
import Toast from 'components/ToastComponent';

const MultiInputComponent = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    rows,
    cols,
    error,
    name,
    size,
    events,
    validators,
    isEditable,
    show,
    error_messages


  } = props;
  const IndirectEval = (evalString) => {
    return eval(evalString)
  }
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : ""

  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [sendReminderToast, setSendReminderToast] = useState({
    status: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    const savedEmails = value || [];
    setEmails(savedEmails);
  }, []);

  useEffect(() => {
    onChange(name, emails);
  }, [emails]);



  const isValidEmail = (email) => {
    const pattern = validators?.pattern?.[0] instanceof RegExp
      ? validators.pattern[0]
      : /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]+$/;

    return pattern.test(email);
  };

  const handleAddEmail = (email) => {
    if (isValidEmail(email) && !emails.includes(email)) {
      setEmails([...emails, email]);
      setInputValue('');
    } else if (isValidEmail(email) == false) {
      // setSendReminderToast({
      //   status: true,
      //   type: "failed",
      //   message: error_messages?.pattern_error ? error_messages?.pattern_error : 'Invalid email address'
      // })
      // setInputValue('');
      toast.error(error_messages?.pattern_error ? error_messages?.pattern_error : 'Invalid email address');
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    setEmails(emails.filter(email => email !== emailToRemove));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddEmail(inputValue.trim());
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };


  return (

    <>{IndirectEval(show) &&


      <div className={size}>
        <Label label={label} validators={validators} />


        <input
          name={name}
          placeholder={placeholder}
          className={`form-email ${errorClass} ${!isEditable && "radioDisabled"}`}
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          disabled={isEditable ? false : true}

        />
        {emails.map((email, index) => (
          <div
            key={index}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#e0e0e0',
              borderRadius: '3px',
              padding: '5px',
              margin: '5px',
            }}
          >
            <span>{email}</span>
            <button
              onClick={() => handleRemoveEmail(email)}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                marginLeft: '5px',
                cursor: 'pointer',
              }}
            >
              &times;
            </button>
          </div>
        ))}

        {
          error?.length !== 0 && (
            <ErrorMessage error={error} />
          )
        }
        {/* {sendReminderToast?.status && (
          <Toast
            type={sendReminderToast?.type}
            message={sendReminderToast?.message}
            autoClose={1000}
          />
        )} */}
              <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} />


      </div>
    }
    </>
  );


}

export default MultiInputComponent